const ja = {
  common: {
    smartPhoneOrder: 'スマホで注文',
    seatNumber: '席番号',
    orderIsNowAvailableWithASmartphone: 'スマホで注文ができるようになりました',
    readTheQrCodeAgainAfterClosingTheApp:
      'アプリを終了した場合は、再度QRコードを読み取ってください',
    orderWithOtherSmartphones: '他のスマホから注文する',
    youCouldOrderWithOtherSmartphonesByReadingTheQrCodeShownOnThisPhone:
      'このスマホで表示するQRコードを読み取ると、他のスマホからも注文ができます',
    showTheQrCode: 'QRコードを表示する',
    youCouldOrderWithAMaximumOf6Smartphones: '最大6台のスマホから、注文できます',
    close: '閉じる',
    howToUse: '使い方',
    doNotDisplayThisDialogAgain: '次回以降表示しない',
    todaysSpecialMenu: '本日のおすすめ',
    cancel: 'キャンセル',
    numberBefore: '',
    numberAfter: '番',
    finishedDishes: '投入皿数',
    dishes: '皿',
    call: '呼出',
    check: 'お会計',
    home: 'MENU',
    search: '検索',
    return: '戻る',
    pleaseWaitTheEmployeeWillArriveShortly: 'ただいま従業員が参ります。\nしばらくお待ちください。',
    cancelTheCall: '呼び出しをキャンセルする',
    orderWithOtherCustomersSmartphone: 'お連れのお客様もスマホで注文する',
    order: '注文する',
    yes: 'はい',
    no: 'いいえ',
    end: '終了する',
    putIn: '投入完了',
    staffCalling: '店員呼び出し',
    smartphoneOrderSuccess: 'スマホで注文を終了',
    certification: '認証中',
    pleaseWait: 'しばらくお待ちください',
    busyTimes: '混み合っていると画面が切り替わるまでに\nお時間がかかる場合があります',
    scanTheQRCodeAgain: '画面が切り替わらない場合は\nお手数ですがQRコードを読み取り直してください',
    recommendMenu: 'おすすめ一覧',
    callStaff: '呼び出し',
    cancelCall: '呼び出しキャンセル',
    yen: '円',
    twGen: '元',
    cnGen: '元',
    dollar: '{price}ドル',
    calorieUnit: 'kcal',
  },
  welcome: {
    smartPhoneOrderDescription:
      'タッチパネルのQRコードを読み取ると、\nスマホから注文ができるサービスです。',
    availableShopList: 'ご利用可能店舗一覧はこちら',
    operationMethod: '操作方法',
    alreadyInstalledApp: 'くら寿司アプリをお持ちの方',
    alreadyInstalledAppDescription:
      'アプリ内の「スマホで注文」ボタンからカメラを起動し、タッチパネルのQRコードを読み取ってください。',
    notInstalledApp: 'くら寿司アプリをお持ちではない方',
    notInstalledAppDescription:
      'カメラアプリを起動し、タッチパネルのQRコードを読み取ってください。',
  },
  preOrder: {
    'pre-orderConfirm': '事前注文内容を送信する',
    pleaseReadTheQrCodeAfterTheGuidance: 'ご案内後にQRコードを読み取ってください',
    'thePre-orderingMenuIs10ForMaximum': '事前注文数は10品までです。',
    appointmentNumber: '予約番号',
    comfirming: '確認中',
    shop: '店',
    receptionNumber: '受付番号',
    reservationUsherTime: '案内予定時刻',
    numberOfReservations: '予約人数',
    preOrder: '事前注文',
    preOrderhowToUseDescription:
      '赤色のボタンを押し\nQRコードを読み込むことで\n注文が送信されます。',
    soldOutDescription: '着席前に品切れになった\n注文は送信されません。',
    preOrderLimitOver: '事前注文枠を超えています。着席後に再度注文が可能です。',
  },
  sideMenu: {
    settings: '設定',
    menuAppearance: 'メニュー表示',
    menuLarge: '大',
    menuSmall: '小',
    languageSettings: '言語設定',
    showTheQrCodeAuthenticationForConnectingWithOtherSmartphones: '子機認証QRを表示する',
    closeTheOrderScreenWithTheSmartphone: 'スマホで注文画面を閉じる',
    regardingSmartPhoneOrder: 'スマホで注文について',
    showAllergenInformation: 'アレルゲン情報を表示する',
  },
  orderHistory: {
    orderHistoryOfThisWholeTableWillBeDisplayed: 'テーブル全体の注文履歴が表示されています。',
    orderHistory: '注文履歴',
    todaysOrderHistory: '本日の注文履歴',
    arrived: 'お届け済み',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-prefix':
      '前回以前のご来店時にご注文いただいた、過去の注文履歴',
    'nMenusOfOrderAtYourLastArrivalAtOurStoreWillBeShown-suffix': '件が表示されています。',
    orderFromSmartphone: 'スマホからのご注文',
    arriveComplete: '送達済',
    orderPending: '注文保留',
    pastOrderHistory: '過去の注文履歴',
    pastOrderHistoryDescription:
      '※31日以内の注文履歴が100件以上ある場合は、最新の注文履歴100件が表示されます。',
  },
  search: {
    searchCandidates: '候補',
    searchDescription: '入力すると候補が表示されます\n候補をタップして確定してください',
    searchResultBefore: '',
    searchResultAfter: 'の検索結果',
    listening: '音声入力受付中',
  },
  howToUse: {
    howToOrderWithTheSmartphone: 'スマホで注文の使い方',
    canOrderWithSmartPhone: 'スマートフォンから注文できます。',
    sideMenuAlsoCanMakeBikkuraPon: 'サイドメニューでも\nビッくらポンができます。',
    canCompleteOrderBeforeMeal: 'お席に座る前に\n注文を決められます。',
    preOrderAfterReserved:
      '予約完了後に予約注文出来るようになります。\n客席のQRコードを読み取った段階で注文が反映されます。',
    noLimitForOrder: '1席で、人数制限なく\nスマホで注文できます。',
    scanQrAndStart: 'タッチパネルのQRコードを読み取ると\nスマホから注文出来るようになります。',
  },
  order: {
    thankYouForYourOrder: 'ご注文ありがとうございます',
    theOrderHasBeenReceived: 'ご注文を承りました',
    arrangeOfSpecialAndPopularMenu: '人気・おすすめの組み合わせ',
    cancelTheCheck: 'お会計をキャンセルする',
    orderCancelConfirmation: '注文をキャンセルしますか？',
    pleaseWait: 'しばらくお待ちください。',
    checkCancelDescription: 'お会計のキャンセルは、\n備え付けのタッチパネルからお願いします。',
    endOrder: 'スマホで注文を終了します',
    askEndOrder: 'スマホで注文を終了します。よろしいですか？',
    endOrderConfirmation: 'スマホで注文を終了しますか？',
    endOrderAttention:
      '他に「スマホで注文」を利用している端末がない場合、本日の注文履歴や、スマホでビッくらポンのポイントは失われます。よろしいですか？',
    endSession: 'セッションが終了されたためスマホで注文を終了します。',
  },
  bikkuraPon: {
    'bikkura-pon': 'サイドメニュービッくらポン！',
    'bikkura-pon-jp': 'スマホでビッくらポン！',
    smartPhoneOrderLimited: 'スマホで注文限定',
    bikkuraPonExplanationBefore: 'このマークがある商品をスマホからご注文頂くと、',
    bikkuraPonExplanationAfter: '毎にビッくらポンを一回遊べます。',
    startBikkuraPon: 'ビッくらポン！で遊ぶ',
    howToStartBikkuraPon: 'タップすると\nビッくらポンが遊べます。',
    pressToStartBikkuraPon: 'タップしてはじめる。\nビッくらポン！で遊ぶ',
    bikkuraPonConfirmation: 'ビッくらポンをプレイしますか？',
    remainingTimes: 'あと {count} 回プレイできます。',
    start: 'プレイ',
    bikkuraPonUnabled: 'ビッくらポンをプレイできませんでした',
    drawingFailure:
      'ビッくらポンの抽選に失敗しました。\n通信環境や残りのプレイ回数をお確かめの上、再度お試しください。',
    bikkuraPonInProgress: 'ビッくらポン抽選中',
    bikkuraPonInProgressDescription:
      '現在、ビッくらポン抽選中です。\nしばらくたってから再度お試しください。',
    congratulations: 'あたり',
    lose: 'はずれ',
  },
  present: {
    arrivedPresent: 'くら寿司からプレゼントが届いております。',
    cannotCancelOperation: '※操作は取り消せません',
    notReceive: '受け取らない',
    receive: '受け取る',
  },
  textInImage: {
    waitingArea: '待合室',
    jackpot: 'あたり',
    lose: 'ハズレ',
    numberPlate: '案内票',
  },
  error: {
    oparateFromTouchPanel: '備え付けのタッチパネルから操作してください。',
    networkError: '通信に失敗しました。',
    '404-title': '404',
    '404-sub-title': 'Not Found',
    '404-text':
      'ページが見つかりませんでした。\n5秒後に「くら寿司 スマホで注文」のTOPページに転送されます。',
    failedToProcess: '処理に失敗しました',
    notFound: 'お探しのページは見つかりません',
    notFoundOrRemoved: 'お探しのページは存在しないか、\n移動もしくは削除された可能性があります。',
    operatingAgainOnTopPage:
      'お手数ですが、「くら寿司 スマホで注文」の\nトップページより、再度お試しください。',
    backToTop: 'トップページへ戻る',
    limitErrorDescription:
      'ただいま大変混み合っているため注文を制限させていただいております。大変申し訳ありませんが少々お待ちください。',
    orderStopErrorDescription:
      'ただいま大変混み合っているため受付を停止させていただいております。大変申し訳ありませんが少々お待ちください。',
    stockoutErrorDescription: '商品の在庫がありませんでした。別の商品をお試しください。',
    orderError:
      'しばらく経ってから再度お試しください。\n解消されない場合は、お手数ですが店舗スタッフへお問い合わせください。',
    unableToAuthenticate: '認証ができませんでした',
    failureToAuthorization: '認証に失敗しました。',
    systemError: 'システムエラー',
    unknownError: '不明なエラーです。',
    unknownErrorDescription: '予期できないエラーのため、アプリがクラッシュしました。',
    pleaseReload: '大変恐れ入りますが、ブラウザをリロードしてください。',
    reload: 'リロード',
  },
  selfcheck: {
    comfirmNumbers: '人数確認',
    singleSeatCheckOut: 'おひとりさまで\n会計されますか？',
    multiSeatsCheckOut:
      '複数の座席をまとめて会計する場合は、\nいいえを選択してください。\n店員がお席までお会計へ伺います。',
    dishesConfirm: 'お皿の確認',
    paymentConfirm: '金額の確認',
    sushiPlate: '寿司皿',
    redPlate: 'えくぼ皿',
    buckleSeparate: '2皿リングは分解',
    putThePlateInThrowingSlot: 'お皿を投入口に\nお入れください。',
    accountingConfirmation: 'お会計 ご確認',
    contents: '内容',
    quantity: '数量',
    totalAmount: '合計金額(税込)',
    checkConfirmed: 'お会計が確定しました。',
    takeNumberPlateToTheCounter: '案内票を持って\nレジにお進みください。',
    checking: '会計中',
    waitUntilRedirect: 'お会計が確定したら\n自動で画面が切り替わります。',
    howToCancelSelfcheck:
      'お会計のキャンセルは、\nお会計中の端末から\nキャンセルボタンをタップするか、\n備え付けのタッチパネルからお願いします。',
    checkOutContentHasBeenChanged: 'お会計内容が変わりました',
    pleaseCheckAgain: 'もう一度ご確認ください。',
    closeCheckPageConfirmation: 'お会計を終了しますか？',
    abortCheckAndBackToMainConfirmation:
      'お会計を終了し、メニュー画面へ戻ります。\nよろしいですか？',
    howToCancelCheckOut: 'お会計のキャンセルは、備え付けのタッチパネルからお願いします。',
    smartphoneOrderFinished: 'スマホで注文を終了',
    staffComingPleaseWait: '店員を呼び出しております。\n少々お待ちください。',
    error: 'エラー',
    failedToLoading: '読み込みに失敗しました',
    selfcheckTryAgainApology:
      '読み込みに失敗したため、\nお会計を中断します。\nメニュー画面へ戻り、\nもう一度最初からやり直してください。',
    backToMainMenu: 'メニュー画面へ戻る',
    selfcheckRestartApology:
      '処理に失敗したため、メニュー画面へ戻ります。\n画面が切り替わらない場合は、お手数ですが備え付けのタッチパネルから戻るボタンをタップし、タッチパネルから操作を行ってください。',
    selfcheckWaitMomentApology:
      'お会計に失敗しました。\nしばらく経ってから再度お試しください。\n解消されない場合は、お手数ですが店員を呼び出すか、備え付けのタッチパネルから操作を行ってください。',
    calling: '呼出',
    confirming: '確認中です',
    useTouchPanel:
      'お手数ですが備え付けのタッチパネルから戻るボタンをタップし、タッチパネルから操作を行ってください。',
  },
  pageTitle: {
    shopMenu: 'メニュー一覧',
    order: '注文する',
    ad: 'おすすめ一覧',
    adOrder: 'おすすめ一覧',
    recommendOrder: 'こちらもおすすめ',
    history: '注文履歴',
    historyOrder: '注文履歴',
    search: '検索',
    searchOrder: '検索',
  },
  siteId: 'スマホで注文 | くら寿司',
}

export default ja
